import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  FlexCenterWrapper, Mr2, GenericWrapper, CursorPointerWrapper,
  TableWrapper, Mt4, FlexCenterBetweenWrapper, Mt1
} from 'wrappers';
import { Icon, SecondaryTextLgBold, SecondaryTextBase } from 'atoms';
import { ChevronDownSvg, ChevronRight } from 'components/icons';
import { formatPrice } from 'utils';
import { ColumnNamesRow, FooterRowContainer, HeaderRowContainer, RowContainer } from './containers';

export const definition = {
  name: 'InspectionReportAreaTable',
  controller: Controller,
  initialProps: ({ area }) => ({ area }),
  props: internalState,
  elements: [
    {
      wrapper: GenericWrapper,
      name: 'Wrapper',
      elements: [
        {
          wrapper: FlexCenterBetweenWrapper,
          name: 'HeaderWrapper',
          elements: [
            {
              wrapper: CursorPointerWrapper,
              name: 'HeaderWrapper',
              isButton: true,
              bindings: ({ isOpen }) => ({ isOpen }),
              elements: [
                {
                  wrapper: FlexCenterWrapper,
                  name: 'Elements',
                  elements: [
                    {
                      component: wrap(wrap(Icon, Mr2), Mt1),
                      name: 'Icon',
                      displayValue: ({ isOpen }) => isOpen ? ChevronDownSvg({ width: 24, height: 24, color: '#9EACB0' }) : ChevronRight({ width: 24, height: 24, color: '#9EACB0' })
                    },
                    {
                      component: SecondaryTextLgBold,
                      name: 'Text',
                      displayValue: ({ area }) => area.name ?? '',
                    },
                  ]
                }
              ]
            },
            {
              component: SecondaryTextBase,
              name: 'TotalCost',
              renderIf: ({ isOpen }) => !isOpen,
              displayValue: ({ area }) => {
                const total = area?.items?.reduce((sum, item) => sum + (item.costs ?? 0), 0);
                return `Total cost: $${formatPrice((total ?? 0) / 100, true)}`;
              },
            }

          ]
        },
        {
          wrapper: Mt4,
          name: '__transparent__',
          elements: [
            {
              wrapper: TableWrapper,
              displayState: ({ }) => ({ borderCollapse: 'separate', borderSpacing: '0px' }),
              name: 'TableWrapper',
              renderIf: ({ isOpen }) => isOpen,
              elements: [
                {
                  component: HeaderRowContainer,
                  name: 'HeaderRowContainer',
                  bindings: ({ }) => ({}),
                },
                {
                  component: ColumnNamesRow,
                  name: 'ColumnNamesRow',
                  bindings: ({ }) => ({}),
                },
                {
                  component: RowContainer,
                  name: 'RowContainer',
                  isListOf: { item: ({ area }) => area.items },
                  bindings: ({ item }) => ({ item }),
                },
                {
                  component: FooterRowContainer,
                  name: 'FooterRowContainer',
                  bindings: ({ area }) => ({ area }),
                },

              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition)